module.exports = __webpack_public_path__ + "d18.no2.5e28f373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d18.no2.jpg
// module id = 5mws
// module chunks = 0